import BaseBlock from "./BaseBlock";
import Hero from "./Hero";
import Testimonials from "./Testimonials";
import Slider from "./Slider";
import TextWithMedia from "./TextWithMedia";
import BeforeAfterGallery from "./BeforeAfterGallery";
import Vote from "./Vote";
import WpImage from "./Core/WpImage";
import Accordion from "./Accordion";
import Cards from "./Cards";
import RecentPosts from "./RecentPosts";
import Tabs from "@/ts/base/Components/Blocks/Tabs";

export default class Initializer {
	constructor() {

		this.initBlocks();

		const hasOverlappingComponents = this.adjustOverlappingComponents();

		if (hasOverlappingComponents) {
			window.addEventListener("resize", this.adjustOverlappingComponents.bind(this), {
				passive: true,
				once: false
			});
		}
	}

	initBlocks(): void {
		const blocks = this.getBlocks();
		for (let cls in blocks) {
			(<NodeListOf<HTMLElement>>window.document.querySelectorAll(cls)).forEach((el, index) => {
				const Block = blocks[cls];
				let block = new Block(el, index);
				block = this.initBlock(block);
				block.init();
			});
		}
	}

	initBlock(block: BaseBlock): BaseBlock {
		return block;
	}

	adjustOverlappingComponents(): boolean {
		const overlappingEls = <NodeListOf<HTMLElement>>document.querySelectorAll("section.acf-block.overlapping");

		overlappingEls.forEach(
			item => {
				const prevSection = item.previousElementSibling;
				const marginTop = window.parseInt(item.style.marginTop);

				if ((prevSection instanceof HTMLElement) && prevSection.classList.contains("acf-block")) {
					prevSection.style.paddingBottom = "";
					prevSection.classList.add("overlapped");

					if (marginTop < 0) {
						let prevSectionPaddingBottom = window.parseInt(window.getComputedStyle(prevSection).paddingBottom);
						if (prevSectionPaddingBottom > 0) {
							prevSection.style.paddingBottom = prevSectionPaddingBottom + Math.abs(marginTop) + "px";
						}
					}
				}

				if (item.classList.contains("next-block-slides-under")) {
					const nextSection = item.nextElementSibling;
					if ((nextSection instanceof HTMLElement) && nextSection.classList.contains("acf-block")) {
						nextSection.style.marginTop = "";
						nextSection.style.zIndex = "";
						nextSection.style.paddingTop = "";

						const nextSectionPaddingTop = window.parseInt(window.getComputedStyle(nextSection).paddingTop);
						let offset = -item.clientHeight - marginTop;

						if (nextSectionPaddingTop > 0) {
							nextSection.style.paddingTop = nextSectionPaddingTop + Math.abs(offset) + "px";
						}
						nextSection.style.marginTop = `${offset}px`;
						nextSection.style.zIndex = (Number.parseInt(item.style.zIndex) - 1).toString();
					}
				}
			}
		);

		return overlappingEls.length > 0;
	}

	getBlocks(): {[p: string]: typeof BaseBlock} {
		return {
			".wp-block-image": WpImage,
			".thee-block-accordion": Accordion,
			".thee-block-cards": Cards,
			".thee-block-hero": Hero,
			".thee-block-recent-posts": RecentPosts,
			".thee-block-slider": Slider,
			".thee-block-testimonials": Testimonials,
			".thee-block-text-with-media": TextWithMedia,
			".thee-block-before-after-gallery": BeforeAfterGallery,
			".thee-block-tabs": Tabs,
			".thee-block-vote": Vote
		};
	}
}
